/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs/><path pid="0" id="calendar" class="cls-1" d="M43.182 122.905h-2.727V121h-1.819v5.714h1.818v-1.9h2.727V139.1H26.818v-14.29h1.818v-1.905h-1.818A1.863 1.863 0 0 0 25 124.81v14.29a1.863 1.863 0 0 0 1.818 1.9h16.364A1.863 1.863 0 0 0 45 139.1v-14.29a1.863 1.863 0 0 0-1.818-1.905zm-11.818 1.905h6.364v-1.905h-6.364V121h-1.818v5.714h1.818v-1.9zm.909 3.809h-3.637v3.81h3.636v-3.81zm4.545 0h-3.636v3.81h3.636v-3.81zm.909 3.81h3.636v-3.81h-3.636v3.81zm-9.091 4.761h3.636v-3.809h-3.636v3.809zm4.545 0h3.636v-3.809h-3.635v3.809z" transform="translate(-25 -121)"/>'
  }
})
